var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var textTracer = require("./fonts/textTracer.js");
var PosAngleData = require("../abstract/posAngleData.js");
var TextToMesh = require("./../threejsExport/textToMesh.js");
var cio_config = require("cio-config");
var units_enum = ["", "μm", "mm", "in", "mil", "pt"];

var TextData = function (pos, angle, text, font, fontSize, fontUnit, strokeWidth, color, anchor, alignment, keepReadable) {
    this.makeObservableTreeNode();

    this.addPosAngle(pos, angle);

    this.text = this.value("text", true);
    this.strokeWidth = this.value("strokeWidth", true, cio_config.types.positive_float.validator);
    this.fontSize = this.value("fontSize", true, cio_config.types.positive_float.validator);
    this.font = this.value("font", true);
    this.fontUnit = this.value("fontUnit", true, cio_config.types.enum(units_enum).validator);
    this.color = this.value("color", true);     // if color == null, color is inherited from layer to which this text is added.
    this.anchor = this.value("anchor", true); // start, middle, end
    this.alignment = this.value("alignment", true); // baseline, central, hanging
    this.keepReadable = this.value("keepReadable", true)

    this.offset = this.cachedFunction("offset",
        this._getOffset,
        [[this, this.onBubble]]
    );

    // empty when not 'pcb text' font
    this.traces = this.cachedFunction("traces",
        this._getTraces,
        [[this, this.onBubble]]
    );

    // for text this is just a trace of the bounding box.
    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [[this, this.onBubble]]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return this.segmentedGeometry().getBB(); },
        [[this.segmentedGeometry, this.segmentedGeometry.onChange]]
    );


    TextToMesh.call(this);

    if (text != undefined) this.text(text);
    else this.text('label');
    if (font != undefined) this.font(font);
    else this.font('Verdana');
    if (fontSize != undefined) this.fontSize(parseFloat(fontSize));
    if (fontUnit != undefined) this.fontUnit(fontUnit);
    else this.fontUnit('');
    if (strokeWidth != undefined) this.strokeWidth(strokeWidth);
    else this.strokeWidth(0);
    if (color != undefined) this.color(color);
    if (anchor != undefined) this.anchor(anchor);
    else this.anchor('start');
    if (alignment != undefined) this.alignment(alignment);
    else this.alignment('baseline');
    if (keepReadable != undefined) this.keepReadable(keepReadable);
    else this.keepReadable(false);
};
lib_core.mixin(TextData, lib_core.ObservableTreeNode);
lib_core.mixin(TextData, PosAngleData);

module.exports = TextData;

lib_core.JsonParser.registerClass(TextData, "TextData");

// raw unrotated bounding box
TextData.prototype.rawBB = function () {
    var self = this;
    var bb = null;
    if (self.font() !== "pcbfont"){ // heuristic font bbox calculation: see cio-build/tasks/FontSizeCalculation.html for derivation of formula and parameters
        var textHeight = 0;
        var textWidth = 0;
        var params = fontParam[self.font().toLowerCase()];
        if (params){
            textHeight = self.fontSize() * params.height;
            for (var i = 0; i < self.text().length; i++){
                let width = params.width[self.text().charCodeAt(i)];
                if(!width) width = params.width[45];
                // default unrecognized characters to '-', same as rendering
                textWidth += width * self.fontSize();
            }
        }
        //var x = self.anchor() == "start" ? 0 : self.anchor() == "middle" ? -textWidth/2 : -textWidth;
        //var y = self.alignment() == "baseline" ? -self.fontSize() : self.alignment() == "central" ? - Math.round(textHeight)/2 : self.fontSize() - textHeight;
        bb = new lib_geometry.BoundingBox(-textWidth/2, -textHeight/2, textWidth, Math.round(textHeight * 2) /2);
        //console.log(bb);
    } else {
        bb = textTracer.getBBox(self.text(), (9 * parseInt(self.fontSize())) / 12);
        //bb = bb.translate(this.offset());
    }
    return bb;
};

TextData.prototype._getOffset = function(){
    var bb = this.rawBB();
    var offset = new lib_geometry.Coord(0, 0);
    switch(this.anchor()) {
        case "start" :
            offset.x = offset.x + bb.width/2;
            break;
        case "middle" :
            break;
        case "end" :
            offset.x = offset.x - bb.width/2;
            break;
    }
    switch(this.alignment()) {
        case "baseline" :
            offset.y = offset.y + bb.height/2;
            break;
        case "central" :
            break;
        case "hanging" :
            offset.y = offset.y - bb.height/2;
            break;
    }
    return offset;
}

// optional value text to get some different text (so for properties i can add '>')
TextData.prototype.getTracesAsPCB = function(text){
    return textTracer.text2traces((text)? text : this.text(), (5 * parseInt(this.fontSize())) / 12, this.offset());
}

TextData.prototype._getTraces = function(){
    if (this.font() !== "pcbfont"){
        return [];
    } else {
        var traces = textTracer.text2traces(this.text(), (9 * parseInt(this.fontSize())) / 12, this.offset());
        return traces;
    }
}

TextData.prototype.getFontFactor = function() {
    var factor = 1;

    switch (this.fontUnit()) {  // convertion factor unit to um
        case "":    factor = 1;  break;
        case "μm":  factor = 1;  break;
        case "mm":  factor = 1/1000;  break;
        case "in":  factor = 1/25400; break;
        case "mil": factor = 1/25.4; break;
        case "pt":  factor = 1/352.77778; break;
        default:
            console.error('fontUnit not known');
    }
    return factor;
};

var fontParam = {
    "verdana": {
        height: 1.2102251407129456,
        width: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.3515625,0.3935550539399625,0.45898510787992497,0.8183601078799244,0.6357425539399625,1.0761726078799243,0.7265625,0.2685550539399622,0.45410104948405255,0.45410104948405255,0.6357425539399625,0.8183601078799244,0.3637691721388366,0.45410104948405255,0.3637691721388366,0.45410104948405255,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.45410104948405255,0.45410104948405255,0.8183601078799244,0.8183601078799244,0.8183601078799244,0.5454104420731704,1,0.6835940431519695,0.6855476078799241,0.6982425539399619,0.7705084720919327,0.6323249296435268,0.5747066721388361,0.7753907715759841,0.751464968339588,0.4208999765478424,0.4545899683395869,0.6928712183395874,0.5566407715759845,0.8427749765478424,0.7480476078799241,0.7871101078799244,0.6030274683395874,0.7871101078799244,0.6953125,0.6835940431519695,0.6162124765478424,0.731933718339588,0.6835940431519695,0.9887691721388369,0.6850587183395874,0.6152351078799241,0.6850587183395874,0.45410104948405255,0.45410104948405255,0.45410104948405255,0.8183601078799244,0.6357425539399625,0.6357425539399625,0.6005874765478424,0.6230476078799241,0.5209962183395866,0.6230476078799241,0.5957032715759847,0.3515625,0.6230476078799241,0.6328125,0.2744135494840524,0.3442379807692307,0.5917976078799241,0.2744135494840524,0.97265654315197,0.6328125,0.6069337183395872,0.6230476078799241,0.6230476078799241,0.4267584720919322,0.5209962183395866,0.3940437382739209,0.6328125,0.5917976078799241,0.8183601078799244,0.5917976078799241,0.5917976078799241,0.5253907715759847,0.6347657715759847,0.45410104948405255,0.6347657715759847,0.8183601078799244]
    },
    // OTHER FONTS SET TO VERDANA UNTIL WE FIGURE OUT HOW TO GET THE RIGHT VALUES.
    // THIS DECISION IS TIED TO VERDANA HARDCODED INTO 2DTEXT RENDERING (for symbols)
    "helvetica": {
        height: 1.2102251407129456,
        width: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.3515625,0.3935550539399625,0.45898510787992497,0.8183601078799244,0.6357425539399625,1.0761726078799243,0.7265625,0.2685550539399622,0.45410104948405255,0.45410104948405255,0.6357425539399625,0.8183601078799244,0.3637691721388366,0.45410104948405255,0.3637691721388366,0.45410104948405255,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.45410104948405255,0.45410104948405255,0.8183601078799244,0.8183601078799244,0.8183601078799244,0.5454104420731704,1,0.6835940431519695,0.6855476078799241,0.6982425539399619,0.7705084720919327,0.6323249296435268,0.5747066721388361,0.7753907715759841,0.751464968339588,0.4208999765478424,0.4545899683395869,0.6928712183395874,0.5566407715759845,0.8427749765478424,0.7480476078799241,0.7871101078799244,0.6030274683395874,0.7871101078799244,0.6953125,0.6835940431519695,0.6162124765478424,0.731933718339588,0.6835940431519695,0.9887691721388369,0.6850587183395874,0.6152351078799241,0.6850587183395874,0.45410104948405255,0.45410104948405255,0.45410104948405255,0.8183601078799244,0.6357425539399625,0.6357425539399625,0.6005874765478424,0.6230476078799241,0.5209962183395866,0.6230476078799241,0.5957032715759847,0.3515625,0.6230476078799241,0.6328125,0.2744135494840524,0.3442379807692307,0.5917976078799241,0.2744135494840524,0.97265654315197,0.6328125,0.6069337183395872,0.6230476078799241,0.6230476078799241,0.4267584720919322,0.5209962183395866,0.3940437382739209,0.6328125,0.5917976078799241,0.8183601078799244,0.5917976078799241,0.5917976078799241,0.5253907715759847,0.6347657715759847,0.45410104948405255,0.6347657715759847,0.8183601078799244]
    },

    "courier": {
        height: 1.2102251407129456,
        width: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.3515625,0.3935550539399625,0.45898510787992497,0.8183601078799244,0.6357425539399625,1.0761726078799243,0.7265625,0.2685550539399622,0.45410104948405255,0.45410104948405255,0.6357425539399625,0.8183601078799244,0.3637691721388366,0.45410104948405255,0.3637691721388366,0.45410104948405255,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.6357425539399625,0.45410104948405255,0.45410104948405255,0.8183601078799244,0.8183601078799244,0.8183601078799244,0.5454104420731704,1,0.6835940431519695,0.6855476078799241,0.6982425539399619,0.7705084720919327,0.6323249296435268,0.5747066721388361,0.7753907715759841,0.751464968339588,0.4208999765478424,0.4545899683395869,0.6928712183395874,0.5566407715759845,0.8427749765478424,0.7480476078799241,0.7871101078799244,0.6030274683395874,0.7871101078799244,0.6953125,0.6835940431519695,0.6162124765478424,0.731933718339588,0.6835940431519695,0.9887691721388369,0.6850587183395874,0.6152351078799241,0.6850587183395874,0.45410104948405255,0.45410104948405255,0.45410104948405255,0.8183601078799244,0.6357425539399625,0.6357425539399625,0.6005874765478424,0.6230476078799241,0.5209962183395866,0.6230476078799241,0.5957032715759847,0.3515625,0.6230476078799241,0.6328125,0.2744135494840524,0.3442379807692307,0.5917976078799241,0.2744135494840524,0.97265654315197,0.6328125,0.6069337183395872,0.6230476078799241,0.6230476078799241,0.4267584720919322,0.5209962183395866,0.3940437382739209,0.6328125,0.5917976078799241,0.8183601078799244,0.5917976078799241,0.5917976078799241,0.5253907715759847,0.6347657715759847,0.45410104948405255,0.6347657715759847,0.8183601078799244]
    }
};



TextData.prototype._getSegmentedGeometry = function () {
    var bb = this.rawBB();
    var poly = bb.getPoly();
    poly = poly.translate(this.offset());
    poly = poly.rotate(this.angle());
    poly = poly.translate(this.pos());

    return poly;
};


TextData.prototype._getMesh = function(info) {
    var geom = this.outlineGeometry();
    var mesh = (new lib_geometry.TriangleMesh()).fromPolygon(geom, this.parent().silkscreenThickness);
    return mesh;
}
